export type AppStorePlatform = 'ios' | 'android';

export type AppStoreClickOptions = {
  placement: string;
  linkType?: 'store' | 'testflight' | 'waitlist';
};

export const trackAppStoreClick = (
  platform: AppStorePlatform,
  { placement, linkType = 'store' }: AppStoreClickOptions
): void => {
  if (typeof window.fbq !== 'function') {
    return;
  }

  window.fbq('trackCustom', 'AppStoreClick', {
    platform,
    placement,
    link_type: linkType,
  });
};

export const onAppStoreClick = (
  platform: AppStorePlatform,
  options: AppStoreClickOptions
): (() => void) => {
  return () => {
    trackAppStoreClick(platform, options);
  };
};
